import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import supabase from "../features/supabase/supabaseSlice";
import stripe from "../features/stripe/stripeSlice";
import openaiApi from "../features/openai/openaiSlice";
export const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
    stripe: stripe.reducer,
    supabase: supabase.reducer,
    openai: openaiApi.reducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(stripe.middleware, supabase.middleware, openaiApi.middleware),
});
